import React from 'react'
import { Route, IndexRoute } from 'react-router'
import Splitter from '../helpers/Splitter'
import SupervisorEventPages from '../components/supervisor/Index'

const ViewSupervisorStudents = Splitter(() =>
  import('../components/supervisor/ViewSupervisorStudents')
)

const SupervisorEventCouponsContainer = Splitter(() =>
  import('../components/supervisor/SupervisorEventCouponsContainer')
)
const SupervisorEventDocumentsContainer = Splitter(() =>
  import('../components/supervisor/SupervisorEventDocumentsContainer')
)
const ViewSupervisorEventsContainer = Splitter(() =>
  import('../components/supervisor/ViewSupervisorEventsContainer')
)
const SupervisorEventPageContainer = Splitter(() =>
  import('../components/supervisor/SupervisorEventPageContainer')
)
const SupervisorEventStudentsContainer = Splitter(() =>
  import('../components/supervisor/SupervisorEventStudentsContainer')
)
const SupervisorEventHostsContainer = Splitter(() =>
  import('../components/supervisor/SupervisorEventHostsContainer')
)
const SupervisorSchoolEventStudentsContainer = Splitter(() =>
  import('../components/supervisor/SupervisorSchoolEventStudentsContainer')
)
const SupervisorEventSchoolsContainer = Splitter(() =>
  import('../components/supervisor/SupervisorEventSchoolsContainer')
)
const SupervisorHostContainer = Splitter(() =>
  import('../components/supervisor/SupervisorHostContainer')
)
const SupervisorCreateHostContainer = Splitter(() =>
  import('../components/supervisor/SupervisorCreateHostContainer')
)
const SupervisorEditPromoCodeContainer = Splitter(() =>
  import('../components/supervisor/SupervisorEditPromoCodeContainer')
)

export const supervisorRoutes = (
  <Route path="supervisor/events">
    <IndexRoute component={ViewSupervisorEventsContainer} />

    <Route
      path=":eventId"
      component={SupervisorEventPages}
    >
      <IndexRoute component={SupervisorEventPageContainer}/>

      <Route path="coupons" component={SupervisorEventCouponsContainer}/>
      <Route path="coupons/:promo_id" component={SupervisorEditPromoCodeContainer}/>

      <Route path="documents" component={SupervisorEventDocumentsContainer}/>

      <Route path="students" component={SupervisorEventStudentsContainer}/>

      <Route path="schools" component={SupervisorEventSchoolsContainer}/>
      <Route path="schools/:schoolId/students" component={SupervisorSchoolEventStudentsContainer}/>

      <Route path="hosts" component={SupervisorEventHostsContainer}/>
      <Route path="hosts/add" component={SupervisorCreateHostContainer}/>
      <Route path="hosts/:hostId" component={SupervisorHostContainer}/>
    </Route>


    <Route
      path=":supervisorId/students"
      component={ViewSupervisorStudents}
    />

  </Route>
)




// WEBPACK FOOTER //
// ./src/routes/supervisorRoutes.js